import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w lh-1 minw-1200 mgx-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "header" }, null, -1)
const _hoisted_3 = { class: "w" }
const _hoisted_4 = {
  class: "w",
  href: ""
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "main" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex fd_c ai_center pdt-100" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-44 text-b" }, "六大产品核心"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-b text-999 mgt-23 text-18" }, "SIX CORE PRODUCTS")
], -1)
const _hoisted_8 = { class: "mgt-25 pdy-75" }
const _hoisted_9 = { class: "flex ai_center jc_center w-1200 mgx-auto" }
const _hoisted_10 = { class: "w-600 h-550 inflex" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"inflex fd_c mgx-58 w-460\"><div class=\"text-36 text-b text-32\">内容产品</div><div class=\"text-14 text-b text-999 mgt-18\">CONTENT PRODUCTS</div><p class=\"text-18 text-b mgt-60 lh-1_4\">课程/班课/图文/音视频多种形式，把内容变成付费产品支持图文、音频、视频、课程等内容形式，上架你的小程序，能够付费购买与使用，实现内容产品化。</p><p class=\"text-18 text-b mgt-60 lh-1_4\">建立结构化内容体系建立体系化的内容产品，满足系统学习需求。</p></div>", 1)
const _hoisted_13 = { class: "minw-1200 bg-f6faf8 pdy-75" }
const _hoisted_14 = { class: "flex ai_center jc_center w-1200 mgx-auto" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"inflex fd_c mgx-58 w-460\"><div class=\"text-36 text-b text-32\">营销玩法</div><div class=\"text-14 text-b text-999 mgt-18\">MARKETING PLAY</div><p class=\"text-18 text-b mgt-60 lh-1_4\">课程/班课/图文/多种裂变+分销玩法，源源不断获取用户，以及推广员等分销玩法，通过用户社交关系就能快速引流获客。</p><p class=\"text-18 text-b mgt-60 lh-1_4\">课程/班课/图文/音视频多种形式，把内容变成付费产品支持图文、音频、视频、课程等内容形式，上架你的小程序，能够付费购买与使用，实现内容产品化。</p><p class=\"text-18 text-b mgt-60 lh-1_4\">建立结构化内容体系建立体系化的内容产品，满足系统学习需求。</p></div>", 1)
const _hoisted_16 = { class: "w-600 h-550 inflex" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "mgt-25 pdy-75" }
const _hoisted_19 = { class: "flex ai_center jc_center w-1200 mgx-auto" }
const _hoisted_20 = { class: "w-600 h-550 inflex" }
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"inflex fd_c mgx-58 w-460\"><div class=\"text-36 text-b text-32\">在线商城</div><div class=\"text-14 text-b text-999 mgt-18\">ONLINE MALL</div><p class=\"text-18 text-b mgt-60 lh-1_4\">开展周边实物售卖、商品、积分兑换等，带来更多额外学员用户，找到新的利润增长点，做强第二条增长曲线。</p><p class=\"text-18 text-b mgt-60 lh-1_4\">小程序商城系统在开发设计上一个较大的益处便是低成本，可以说只需有着一部手机，就可以完成开发设计的目的，那麼针对具有的手机淘宝的应用的作用，可以说使小程序商城系统更强的营销推广。现阶段小程序商城系统对中小企业、线下推广店面都能够有着，开发设计门槛低；</p></div>", 1)
const _hoisted_23 = { class: "minw-1200 bg-f6faf8 pdy-75" }
const _hoisted_24 = { class: "flex ai_center jc_center w-1200 mgx-auto" }
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"inflex fd_c mgx-58 w-460\"><div class=\"text-36 text-b text-32\">在线音视频</div><div class=\"text-14 text-b text-999 mgt-18\">ONLINE AUDIO AND VIDEO</div><p class=\"text-18 text-b mgt-60 lh-1_4\">低成本，高创收的在线课程</p><p class=\"text-18 text-b mgt-60 lh-1_4\">教学增值，获得更高续费<br>实现线下课的补充，提供学员更多价值， 获得新老学员更高续费。</p><p class=\"text-18 text-b mgt-60 lh-1_4\">运营灵活，保障课消进度<br>疫情线下无法消课时，随时转移线上，保 证课消进度，保障资金安全。</p></div>", 1)
const _hoisted_26 = { class: "w-600 h-550 inflex" }
const _hoisted_27 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_popup_contact = _resolveComponent("popup-contact")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", _hoisted_4, [
        _createElementVNode("img", {
          class: "w h",
          "data-img": "/index/a1.png",
          src: _ctx.state.imgUrl + '/index/a1.png',
          alt: "banner"
        }, null, 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              class: "w h",
              "data-img": "/index/b1.png",
              src: _ctx.state.imgUrl + '/index/b1.png',
              alt: ""
            }, null, 8, _hoisted_11)
          ]),
          _hoisted_12
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("img", {
              class: "w h",
              "data-img": "/index/b2.png",
              src: _ctx.state.imgUrl + '/index/b2.png',
              alt: ""
            }, null, 8, _hoisted_17)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("img", {
              class: "w h",
              "data-img": "/index/b3.png",
              src: _ctx.state.imgUrl + '/index/b3.png',
              alt: ""
            }, null, 8, _hoisted_21)
          ]),
          _hoisted_22
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("img", {
              class: "w h",
              "data-img": "/index/b4.png",
              src: _ctx.state.imgUrl + '/index/b4.png',
              alt: ""
            }, null, 8, _hoisted_27)
          ])
        ])
      ])
    ]),
    _createVNode(_component_popup_contact)
  ]))
}